module.exports = __webpack_public_path__ + "img/cbam-4.c395c5bc.png";